
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.364 0S8.86 5.825 6.396 12.902a4.562 4.562 0 00.512 4.012c.676 1.034 1.576 2.274 4.433 5.065a6.697 6.697 0 012.111 4.627v1.309c.503.098 1.013.158 1.525.18V21.02l-4.99-5.882a.379.379 0 01.047-.539.393.393 0 01.548.047l4.41 5.173v-6.346L11.97 9.818a.377.377 0 01.09-.474.391.391 0 01.49-.009l2.421 2.927V6.308c0-.102.042-.2.115-.272a.394.394 0 01.552 0c.074.072.115.17.115.272v5.954l2.421-2.927a.39.39 0 01.688.203c.01.1-.02.201-.085.28l-3.024 3.655v6.358l4.41-5.172a.385.385 0 01.266-.173.393.393 0 01.41.207.375.375 0 01-.08.445l-5.006 5.882v7.078a9.717 9.717 0 001.525-.183v-1.306a6.712 6.712 0 012.11-4.627c2.858-2.79 3.758-4.03 4.437-5.065a4.56 4.56 0 00.513-4.015C21.866 5.812 15.363 0 15.363 0z","fill":"#43963B"}}),_c('path',{attrs:{"d":"M6.686 17.799c-.651-.97-1.11-1.591-1.628-1.438-.518.153-.922 1.287-.04 2.59.63.938 2.303 3.232 2.05 3.469-.255.237-1.63.028-3.007-1.875a9.445 9.445 0 01-1.84-3.965c-.43-1.81-.147-5.14-1.814-5.165-.623 0-.362 4.259-.3 5.709.068 1.665.674 5.062 2.045 6.562s4.176 2.734 5.091 4.374c.518.756.785 1.962.86 3.475l.765 3.437c1.393.486 2.835.83 4.303 1.028v-9.077a5.568 5.568 0 00-1.83-3.925c-3.069-2.928-4-4.228-4.655-5.2zM23.488 31.898c.045-1.702.325-3.032.881-3.853.918-1.626 3.76-2.903 5.088-4.37 1.328-1.468 1.975-4.896 2.047-6.556.058-1.45.325-5.714-.303-5.704-1.666.025-1.383 3.353-1.813 5.16a9.397 9.397 0 01-1.848 3.978c-1.39 1.873-2.75 2.091-3.005 1.873-.253-.219 1.413-2.55 2.064-3.472.882-1.302.462-2.435-.04-2.588-.5-.153-.976.468-1.626 1.436-.651.968-1.589 2.27-4.651 5.195a5.563 5.563 0 00-1.843 3.934V36a22.088 22.088 0 004.863-1.22","fill":"#43963B"}})])
          )
        }
      }
    